module.exports = __webpack_public_path__ + "img/pad-not-selected.f7c1167f.png";